import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading, SecondaryButton } from './ui/UI';
import { ArrowRight } from 'lucide-react';
const flow = ['Advisory', 'Baseline', 'Missing signals', 'Validation plan', 'Remediation', 'Readiness report'];
export function ThreatCenterTeaser() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-1322">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1323">
        <SectionLabel number="06" label="Threat Center" className="mb-8" data-id="element-1324" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-1325">
          <div className="lg:col-span-7" data-id="element-1326">
            <SectionHeading size="xl" data-id="element-1327">
              New threat advisory?
              <br data-id="element-1328" />
              <span className="text-white/40" data-id="element-1329">
                Turn it into a validation plan.
              </span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-5 lg:pt-4" data-id="element-1330">
            <p className="text-lg text-white/60 leading-relaxed mb-6" data-id="element-1331">
              Periscan Threat Center converts CISA alerts, CVEs, vendor
              advisories, TTPs, and threat intel into customer-specific
              validation plans, remediation actions, fix verification, and
              readiness reports.
            </p>
            <SecondaryButton href="#" size="md" data-id="element-1332">
              Coming Soon
            </SecondaryButton>
          </div>
        </div>

        <div className="p-8 rounded-2xl bg-[#070a0e] border border-white/5" data-id="element-1333">
          <p className="font-mono text-[10px] uppercase tracking-widest text-[#1a8fd4] mb-6" data-id="element-1334">
            Advisory Workflow
          </p>
          <div className="flex flex-wrap items-center gap-3" data-id="element-1335">
            {flow.map((node, i) => <Fragment key={i} data-id="element-1336">
                <div className="px-4 py-2.5 rounded-lg bg-[#1a8fd4]/10 border border-[#1a8fd4]/30" data-id="element-1337">
                  <span className="font-mono text-xs text-white" data-id="element-1338">{node}</span>
                </div>
                {i < flow.length - 1 && <motion.div initial={{
              width: 0
            }} whileInView={{
              width: 'auto'
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: i * 0.15
            }} className="flex items-center" data-id="element-1339">
                    <ArrowRight className="w-4 h-4 text-[#1a8fd4]/60" data-id="element-1340" />
                  </motion.div>}
              </Fragment>)}
          </div>
        </div>
      </div>
    </section>;
}